import { render, staticRenderFns } from "./userPhysicalReport.vue?vue&type=template&id=25666acc&"
import script from "./userPhysicalReport.vue?vue&type=script&lang=js&"
export * from "./userPhysicalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports